import * as Sentry from '@sentry/browser';
import Environment from '../Enviroment';

Sentry.init({
  dsn: Environment.sentryDSN,
  environment: Environment.environment,
});

export default Sentry;
